import styled from 'styled-components';
import { Button } from 'antd';

export const StyledButton = styled(Button)`
  ${({ padding }) => padding && `padding: ${padding}`};
  margin: ${({ margin }) => margin || '0px 0px'};
`;
